export default __webpack_public_path__ + "static/media/mp4.7d7d4ee2.png";